import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React from "react";

type Props = {
  title: string;
  children: (JSX.Element | null)[];
};

export const MapAreaAccordion = ({ title, children }: Props): JSX.Element => {
  const [expanded, setExpanded] = React.useState(false);
  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      disableGutters
      expanded={expanded}
      onChange={(_e, v) => setExpanded(v)}
      square
      sx={{
        backgroundColor: (theme) => theme.palette.primary.semiLight,
        color: (theme) => theme.palette.primary.contrastText,
        borderTop: (theme) => `1px solid ${theme.palette.primary.dark}`,
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{ color: (theme) => theme.palette.primary.contrastText }}
          />
        }
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pr: 0, pl: 1 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
